import request from "@/utils/request";
// 获取接收人列表
export function getSubAccountMonitorMsg(params) {
  return request({
    url: "/h5/setting/getSubAccountMonitorMsg",
    method: "post",
    params,
  });
}

// 保存子账号监控消息类型
export function saveSubAccountMonitorMsg(params) {
  return request({
    url: "/h5/setting/saveSubAccountMonitorMsg",
    method: "post",
    params,
  });
}